import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Router from './route/Router';
import ThemeProvider from '#/styles/ThemeProvider';
import { routeComponents } from '#/route/routeComponents';
import { Themes } from '#/types/enums';
import { updateSiteTheme } from '#/store/reducers/config/config';
import { initializeWidget } from '#/store/reducers/audd/auddThunks';
import { selectIsInitialized, selectInitError } from '#/store/reducers/audd/auddSlice';
import { selectSiteTheme } from '#/store/reducers/config/config';
import { getUrlParams } from '#/util/urlParams';
import { AppDispatch } from '#/store/store';

const App: React.FC = (): JSX.Element => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useSelector(selectSiteTheme);
  const isInitialized = useSelector(selectIsInitialized);
  const initError = useSelector(selectInitError);

  useEffect(() => {
    const { theme: urlTheme } = getUrlParams();
    if (urlTheme === 'dark' || urlTheme === 'light') {
      dispatch(updateSiteTheme(urlTheme as Themes));
    }
    dispatch(initializeWidget());
  }, [dispatch]);

  if (initError) {
    return (
      <ThemeProvider theme={theme}>
        <div className="audd-error">{initError}</div>
      </ThemeProvider>
    );
  }

  if (!isInitialized) {
    return (
      <ThemeProvider theme={theme}>
        <div className="audd-loading">
          <i className="fa fa-spinner fa-spin" />
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Router components={{ ...routeComponents }} />
    </ThemeProvider>
  );
};

export default App;
